/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementMappingBase.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementMappingBase>): JiraServiceManagementMappingBase {
        let obj = Object.assign(new JiraServiceManagementMappingBase(), model);
        JiraServiceManagementMappingBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementMappingBase>): JiraServiceManagementMappingBase {
        if (!model) return null;
        return JiraServiceManagementMappingBase.newInstance(<JiraServiceManagementMappingBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementMappingBase) {
        if (!obj) return;

        models.JiraServiceManagementMappingBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementMappingBase): boolean {
        Object.setPrototypeOf(obj, JiraServiceManagementMappingBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Sample Format text of incident description by selected description attributes.
     */
    description_text: string;

}
